import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  Grid,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  InputLabel,
  TextField,
  MenuItem,
  makeStyles,
  Container,
  CardHeader,
  CardContent,
  Divider,
  TableContainer,
  TablePagination,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import { LoadingComponent } from 'src/utils/newLoader';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, DatePicker } from "@material-ui/pickers";
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const getPageMargins = () => {
  return `@media print {
          @page {
          background-color: white !important;
          size: A4 landscape !important;
      }
            body {
          background-color: white !important;
      }
  }`;
};

const screenCode = 'BLADVANCEREPORT';

export default function BLAdvanceReport(props) {
  const [title, setTitle] = useState("BL Advance Report");
  const classes = useStyles();
  const [groupList, setGroupList] = useState([]);
  const [factoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState([]);
  const [cropSupplyInput, setCropSupplyInput] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0
  });
  const [blReportDetails, setBLReportDetails] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    startDate: '',
    endDate: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const componentRef = useRef();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [displayedMonthColumns, setDisplayedMonthColumns] = useState([]);
  const [currentMonthPaymentDetails, setCurrentMonthPaymentDetails] = useState({});
  const startMonth = startDate.toLocaleString('default', { month: 'long' });
  const startYear = startDate.getFullYear();
  const endMonth = endDate.toLocaleString('default', { month: 'long' });
  const endYear = endDate.getFullYear();

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    if (cropSupplyInput.groupID > 0) {
      trackPromise(getFactoriesForDropdown());
    }
  }, [cropSupplyInput.groupID]);

  useEffect(() => {
    if (cropSupplyInput.factoryID > 0) {
      trackPromise(getRoutesByFactoryID());
    }
  }, [cropSupplyInput.factoryID]);

  async function getPermission() {
    const permissions = await authService.getPermissionsByScreen(screenCode);
    const isAuthorized = permissions.find(p => p.permissionCode === 'VIEWBLADVANCEREPORT');

    if (!isAuthorized) {
      navigate('/404');
    }

    const isGroupFilterEnabled = permissions.find(p => p.permissionCode === 'GROUPDROPDOWN');
    const isFactoryFilterEnabled = permissions.find(p => p.permissionCode === 'FACTORYDROPDOWN');

    setPermissions({
      isGroupFilterEnabled: !!isGroupFilterEnabled,
      isFactoryFilterEnabled: !!isFactoryFilterEnabled,
    });

    setCropSupplyInput({
      ...cropSupplyInput,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(cropSupplyInput.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(cropSupplyInput.factoryID);
    setRouteList(routes);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: groupList[searchForm.groupID],
      factoryName: factoryList[searchForm.factoryID],
      startDate: moment(searchForm.startDate).format('YYYY-MM-DD'),
      endDate: moment(searchForm.endDate).format('YYYY-MM-DD'),
      routeID: routeList[searchForm.routeID]
    });
  }

  async function getDetails() {
    const model = {
      groupID: parseInt(cropSupplyInput.groupID),
      factoryID: parseInt(cropSupplyInput.factoryID),
      routeID: parseInt(cropSupplyInput.routeID),
      startDate: moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
    };

    getSelectedDropdownValuesForReport(model);

    try {
      const response = await services.GetBLAdvanceReportByDateRange(model);
      setBLReportDetails(response);

      const paymentSums = {};

      response.forEach((item) => {
        const regNumber = item.registrationNumber;

        if (!paymentSums[regNumber]) {
          paymentSums[regNumber] = {
            ...item.currentMonthPaymentDetails,
            name: item.name,
            loanBalance: item.loanBalance,
            cropDetailsModelTotal: 0,
          };
        }


        if (item.currentMonthPaymentDetails.cropDetailsModel) {
          paymentSums[regNumber].cropDetailsModelTotal +=
            item.currentMonthPaymentDetails.cropDetailsModel.reduce(
              (sum, crop) => sum + crop.minRate * crop.totalCrop,
              0
            );
        }

        if (item.currentMonthPaymentDetails.deductionDetaiList) {
          paymentSums[regNumber].cropDetailsModelTotal -=
            item.currentMonthPaymentDetails.deductionDetaiList.reduce((sum, deduction) => {
              if (deduction.entryType === 1) {
                return sum - (deduction.totalAmount || 0);
              } else if (deduction.entryType === 2) {
                return sum + (deduction.totalAmount || 0);
              }
              return sum;
            }, 0);
        }

        const totalSum = (paymentSums[regNumber].cropDetailsModelTotal || 0) - item.currentMonthPaymentDetails.balanceCarryForward;

        paymentSums[regNumber].currentBalance = totalSum;
      });

      setCurrentMonthPaymentDetails(paymentSums);

      const updatedBLReportDetails = response.map((item) => ({
        ...item,
        currentBalance: paymentSums[item.registrationNumber]?.currentBalance || 0,
      }));

      setBLReportDetails(updatedBLReportDetails);

      const months = getMonthColumns(startDate, endDate);
      setDisplayedMonthColumns(months);
    } catch (error) {
      throw error
    }
  }

  function generateDropDownMenu(data) {
    return data ? Object.entries(data).map(([key, value]) => (
      <MenuItem key={key} value={key}>{value}</MenuItem>
    )) : [];
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setCropSupplyInput({
      ...cropSupplyInput,
      [name]: value
    });
    setBLReportDetails([]);
  }

  function handleDateChange(date, type) {
    const newDate = new Date(date);
    const currentDate = new Date();

    if (type === 'start') {
      const minStartDate = new Date(endDate);
      minStartDate.setMonth(minStartDate.getMonth() - 12);

      if (newDate < minStartDate) {
        setStartDate(minStartDate);
      } else {
        setStartDate(newDate);
      }
    } else if (type === 'end') {
      const maxEndDate = currentDate;

      const minEndDate = new Date(currentDate);
      minEndDate.setMonth(minEndDate.getMonth() - 12);

      if (newDate > maxEndDate) {
        setEndDate(maxEndDate);
      }
      else if (newDate < minEndDate) {
        setEndDate(minEndDate);
      } else {
        setEndDate(newDate);
      }
    }
    setBLReportDetails([]);
  }

  const getMonthColumns = (startDate, endDate) => {
    const months = [];
    let currentDate = new Date(startDate);

    while (currentDate <= new Date(endDate)) {
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      months.push(`${year}-${month}`);
      currentDate.setMonth(currentDate.getMonth() + 1);
    }

    return months;
  };

  const formatNumber = (value) => {
    return parseFloat(value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  async function createDataForExcel(array) {
    var res = [];

    const startMonth = startDate.toLocaleString('default', { month: 'long' });
    const startYear = startDate.getFullYear();
    const endMonth = endDate.toLocaleString('default', { month: 'long' });
    const endYear = endDate.getFullYear();
    if (array != null) {
      array.forEach((x) => {
        var vr = {
          'Registration Number': x.registrationNumber,
          'Customer Name': x.name,
        };

        for (const [month, weight] of Object.entries(x.monthlyCropWeights || {})) {
          vr[month] = weight;
        }

        const nonZeroMonths = Object.entries(x.monthlyCropWeights || {}).filter(([month, weight]) => weight > 0);
        const totalQty = nonZeroMonths.reduce((sum, [month, weight]) => sum + weight, 0);
        const avgQty = nonZeroMonths.length > 0 ? totalQty / nonZeroMonths.length : 0;

        vr['Total QTY'] = totalQty.toFixed(2);
        vr['Average QTY'] = avgQty.toFixed(2);
        vr['Loan Balance'] = x.loanBalance || 0;
        vr['Current Balance'] = x.currentBalance || 0;

        res.push(vr);
      });

      var totalRow = {};
      res.forEach((row) => {
        Object.keys(row).forEach((key) => {
          if (key !== 'Registration Number' && key !== 'Customer Name') {
            totalRow[key] = (totalRow[key] || 0) + (parseFloat(row[key]) || 0);
          }
        });
      });

      var totalRow = {};
      res.forEach((row) => {
        Object.keys(row).forEach((key) => {
          if (key !== 'Route Name' && key !== 'Registration Number' && key !== 'Customer Name') {
            totalRow[key] = (totalRow[key] || 0) + (row[key] || 0);
          }
        });
      });

      res.push({});

      res.push({
        'Registration Number': 'Group - ' + selectedSearchValues.groupName,
        'Customer Name': 'Factory - ' + selectedSearchValues.factoryName,
      });

      res.push({
        'Registration Number': 'Route - ' + (selectedSearchValues.routeID === undefined ? 'All Route' : selectedSearchValues.routeID),
      });

      res.push({
        'Registration Number': 'Start Month - ' + startMonth + startYear,
        'Customer Name': 'End Month - ' + endMonth + endYear,
      });
    }

    return res;
  }

  async function createFile() {

    var file = await createDataForExcel(blReportDetails);
    var settings = {
      sheetName: 'BL Advance Report',
      fileName:
        'BL Advance Report - ' +
        selectedSearchValues.groupName +
        ' - ' +
        selectedSearchValues.factoryName +
        ' - ' +
        selectedSearchValues.routeName +
        ' - ' +
        selectedSearchValues.startDate +
        ' to ' +
        selectedSearchValues.endDate,
      writeOptions: {},
    };

    let keys = Object.keys(file[0]);
    let tempcsvHeaders = [];
    keys.forEach((key) => {
      tempcsvHeaders.push({ label: key, value: key });
    });

    let dataA = [
      {
        sheet: 'BL Advance Report',
        columns: tempcsvHeaders,
        content: file,
      },
    ];

    xlsx(dataA, settings);
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: cropSupplyInput.groupID,
              factoryID: cropSupplyInput.factoryID,
              routeID: cropSupplyInput.routeID,
              startDate: startDate,
              endDate: endDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
              factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
              routeID: Yup.number().required('Route is required').min("1", 'Route is required'),
              startDate: Yup.date().required('From Date is Required'),
              endDate: Yup.date().required('To Date is Required'),
            })}
            onSubmit={() => trackPromise(getDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={title} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={cropSupplyInput.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={handleChange}
                              value={cropSupplyInput.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.routeID && errors.routeID)}
                              fullWidth
                              helperText={touched.routeID && errors.routeID}
                              name="routeID"
                              onChange={handleChange}
                              value={cropSupplyInput.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Start Month *"
                                helperText="Select applicable month"
                                value={startDate}
                                onChange={(date) => handleDateChange(date, 'start')}
                                maxDate={endDate} // Start date cannot be after end date
                                minDate={new Date(new Date(endDate).setMonth(endDate.getMonth() - 12))} // Start date cannot be more than 12 months before end date
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="End Month *"
                                helperText="Select applicable month"
                                value={endDate}
                                onChange={(date) => handleDateChange(date, 'end')}
                                maxDate={new Date()} // End date cannot be in the future
                                minDate={new Date(new Date().setMonth(new Date().getMonth() - 12))} // End date cannot be more than 12 months before current date
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>

                      <Box minWidth={1050}>
                        {blReportDetails.length > 0 ? (
                          <TableContainer>
                            <Table aria-label="caption table" size='small'>
                              <TableHead>
                                <TableRow style={{ border: '1px solid #ccc' }}>
                                  <TableCell align="center" rowSpan={2} style={{ border: '1px solid #ccc' }}>
                                    Reg No
                                  </TableCell>
                                  <TableCell align="center" rowSpan={2} style={{ border: '1px solid #ccc' ,fontSize: "12px", padding: '5px'}}>
                                    Name
                                  </TableCell>

                                  <TableCell
                                    align="center"
                                    colSpan={displayedMonthColumns.length}
                                    style={{ border: '1px solid #ccc', fontWeight: 'bold' , fontSize: "12px", padding: '5px'}} 
                                  >
                                    Month
                                  </TableCell>

                                  <TableCell align="center" rowSpan={2} style={{ border: '1px solid #ccc' }}>
                                    Total QTY
                                  </TableCell>
                                  <TableCell align="center" rowSpan={2} style={{ border: '1px solid #ccc' }}>
                                    Average QTY
                                  </TableCell>
                                  <TableCell align="center" rowSpan={2} style={{ border: '1px solid #ccc' }}>
                                    Loan Balance
                                  </TableCell>
                                  <TableCell align="center" rowSpan={2} style={{ border: '1px solid #ccc' }}>
                                    Current Balance
                                  </TableCell>
                                  <TableCell align="center" rowSpan={2} style={{ border: '1px solid #ccc' }}>
                                    Request Amount
                                  </TableCell>
                                  <TableCell align="center" rowSpan={2} style={{ border: '1px solid #ccc' }}>
                                    Supervisor Approve
                                  </TableCell>
                                  <TableCell align="center" rowSpan={2} style={{ border: '1px solid #ccc' }}>
                                    Manager Approve
                                  </TableCell>
                                </TableRow>

                                <TableRow>
                                  {displayedMonthColumns.map((month, index) => (
                                    <TableCell key={index} align="center" style={{ border: '1px solid #ccc', fontWeight: 'bold' , fontSize: "12px", padding: '5px'}}>
                                      {month}
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {blReportDetails.slice(page * limit, page * limit + limit).map((data, index) => {
                                  const nonZeroMonths = Object.entries(data.monthlyCropWeights || {}).filter(([month, weight]) => weight > 0);
                                  const totalQty = nonZeroMonths.reduce((sum, [month, weight]) => sum + weight, 0);
                                  const avgQty = nonZeroMonths.length > 0 ? totalQty / nonZeroMonths.length : 0;

                                  return (
                                    <TableRow key={index} style={{ border: '1px solid #ccc' }}>
                                      <TableCell align="left" style={{ border: '1px solid #ccc' }}>
                                        {data.registrationNumber}
                                      </TableCell>
                                      <TableCell align="left" style={{ border: '1px solid #ccc' ,fontSize: "12px", padding: '5px'}}>
                                        {data.name}
                                      </TableCell>

                                      {displayedMonthColumns.map((month, idx) => (
                                        <TableCell key={idx} align="right" style={{ border: '1px solid #ccc' }}>
                                          {/* {data.monthlyCropWeights?.[month] ?? '0.00'} */}
                                          {formatNumber(data.monthlyCropWeights?.[month] ?? '0.00')}
                                        </TableCell>
                                      ))}

                                      <TableCell align="right" style={{ border: '1px solid #ccc' }}>
                                        {formatNumber(totalQty)}
                                      </TableCell>
                                      <TableCell align="right" style={{ border: '1px solid #ccc' }}>
                                        {formatNumber(avgQty)}
                                      </TableCell>
                                      <TableCell align="right" style={{ border: '1px solid #ccc' }}>
                                        {formatNumber(data.loanBalance)}
                                      </TableCell>
                                      <TableCell align="right" style={{ border: '1px solid #ccc' }}>
                                        {formatNumber(data.currentBalance)}
                                      </TableCell>
                                      <TableCell align="center" style={{ border: '1px solid #ccc' }}></TableCell>
                                      <TableCell align="center" style={{ border: '1px solid #ccc' }}></TableCell>
                                      <TableCell align="center" style={{ border: '1px solid #ccc' }}></TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                            <TablePagination
                              component="div"
                              count={blReportDetails.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer>
                        ) : null}
                      </Box>

                      {blReportDetails.length > 0 ? (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle="BL Advance Report"
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              blReportDetails={blReportDetails}
                              displayedMonthColumns={displayedMonthColumns}
                              selectedSearchValues={selectedSearchValues}
                            />
                          </div>
                        </Box>
                      ) : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
